/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vintage_Nike_DunksInputs */

const en_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vintage Nike Dunks`)
};

const es_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vintage Nike Dunks`)
};

const fr_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nike Dunks Vintage`)
};

const de_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vintage Nike Dunks`)
};

const ja_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヴィンテージ Nike Dunks`)
};

const zh_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复古 Nike Dunks`)
};

const ar_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذاء Nike Dunks كلاسيكي`)
};

const id_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nike Dunks Vintage`)
};

const it_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nike Dunks Vintage`)
};

const ru_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Винтажные Nike Dunks`)
};

const pt_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nike Dunks Vintage`)
};

const ko_vintage_nike_dunks = /** @type {(inputs: Vintage_Nike_DunksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈티지 나이키 덩크`)
};

/**
* | output |
* | --- |
* | "Vintage Nike Dunks" |
*
* @param {Vintage_Nike_DunksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vintage_nike_dunks = /** @type {((inputs?: Vintage_Nike_DunksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vintage_Nike_DunksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vintage_nike_dunks(inputs)
	if (locale === "es") return es_vintage_nike_dunks(inputs)
	if (locale === "fr") return fr_vintage_nike_dunks(inputs)
	if (locale === "de") return de_vintage_nike_dunks(inputs)
	if (locale === "ja") return ja_vintage_nike_dunks(inputs)
	if (locale === "zh") return zh_vintage_nike_dunks(inputs)
	if (locale === "ar") return ar_vintage_nike_dunks(inputs)
	if (locale === "id") return id_vintage_nike_dunks(inputs)
	if (locale === "it") return it_vintage_nike_dunks(inputs)
	if (locale === "ru") return ru_vintage_nike_dunks(inputs)
	if (locale === "pt") return pt_vintage_nike_dunks(inputs)
	return ko_vintage_nike_dunks(inputs)
});